import React from 'react';

interface IconProps {
    fill?: string;
    width?: number;
    height?: number;
}

export const DocumentIcon = ({ fill = '#252733', width = 9, height = 9 }: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 9 9"
        fill="none"
    >
        <g clipPath="url(#clip0_2137_457)">
            <path
                d="M2.625 4.5H6.375V5.25H2.625V4.5ZM2.625 6.75H5.25V6H2.625V6.75ZM8.25 2.84475V9H0.75V1.125C0.75 0.826631 0.868526 0.540483 1.0795 0.329505C1.29048 0.118526 1.57663 0 1.875 0L5.40525 0L8.25 2.84475ZM5.625 2.625H6.96975L5.625 1.28025V2.625ZM7.5 8.25V3.375H4.875V0.75H1.875C1.77554 0.75 1.68016 0.789509 1.60984 0.859835C1.53951 0.930161 1.5 1.02554 1.5 1.125V8.25H7.5Z"
                fill={fill}
            />
        </g>
        <defs>
            <clipPath id="clip0_2137_457">
                <rect width={width} height={height} fill="white" />
            </clipPath>
        </defs>
    </svg>
);
